<template>
  <div>
    <v-container fluid class="content-wrapper px-4 px-md-16">
      <v-row>
        <v-col cols="12" md="auto">
          <v-btn
            depressed
            rounded
            small
            color="blue"
            class="white--text font-weight-bold"
            @click="goBack"
          >
            <v-icon color="black" small class="mr-2">
              mdi-arrow-left
            </v-icon>
            Back
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <label class="text-bold subtitle-2">{{ $t('email') }}</label>
          <v-text-field
            v-model="user.email"
            :placeholder="$t('email')"
            type="text"
            outlined
            :disabled="!edit"
            class="pt-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <label class="text-bold subtitle-2">{{ $t('firstname') }}</label>
          <v-text-field
            v-model="user.firstname"
            :placeholder="$t('firstname')"
            type="text"
            outlined
            :disabled="!edit"
            class="pt-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <label class="text-bold subtitle-2">{{ $t('lastname') }}</label>
          <v-text-field
            v-model="user.lastname"
            :placeholder="$t('lastname')"
            type="text"
            outlined
            :disabled="!edit"
            class="pt-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <label class="text-bold subtitle-2">{{ $t('phone') }}</label>
          <v-text-field
            v-model="user.phone"
            :placeholder="$t('phone')"
            type="text"
            outlined
            :disabled="!edit"
            class="pt-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <label class="text-bold subtitle-2">{{ $t('affiliation') }}</label>
          <v-text-field
            v-model="user.affiliation"
            :placeholder="$t('position')"
            type="text"
            outlined
            :disabled="!edit"
            class="pt-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <label class="text-bold subtitle-2">{{ $t('institution') }}</label>
          <v-text-field
            v-if="user.institutionText"
            class="pt-2"
            v-model="user.institutionText"
            :placeholder="$t('institution')"
            outlined
            disabled
          >
          </v-text-field>
          <v-text-field
            v-else
            class="pt-2"
            v-model="user.institution"
            :placeholder="$t('institution')"
            outlined
            disabled
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus';

export default {
  name: 'User',
  data() {
    return {
      breadcrumbs: this.$router.currentRoute.meta.breadcrumbPath,
      user: {
        email: null,
        firstname: null,
        lastname: null,
        accept: null,
        institution: null,
        affiliation: null,
        queryProvider: '',
        queryInstitutionId: '',
      },
      edit: false,
    };
  },
  mounted() {
    this.queryProvider = this.$route.query.provider;
    this.queryInstitutionId = this.$route.query.institutionId;
    let id = this.$route.params.id;
    EventBus.$emit('waiting', true);
    this.axios
      .get('/api/v1/users/' + id)
      .then(res => {
        this.user = res.data;
        this.$set(this.breadcrumbs, this.breadcrumbs.length - 1, { text: this.user.fullName });
      })
      .catch(error => {
        console.log({ error });
      })
      .finally(() => {
        EventBus.$emit('waiting', false);
      });
    this.axios
      .get('/api/v1/resources?providers=' + id)
      .then(res => {
        this.resources = res.data.content;
      })
      .catch(error => {
        console.log({ error });
      });
  },
  methods: {
    goBack() {
      if (
        this.queryProvider &&
        this.queryInstitutionId &&
        this.$store.getters.roles === 'provider'
      ) {
        const adminMember = true;
        const id = this.queryInstitutionId;
        this.$router.push({
          name: 'AdminMembersOfInstitutions',
          params: { id: id },
          query: { adminMember },
        });
      } else if (this.$route.query.equipmentOrders && this.$store.getters.roles === 'super-admin') {
        this.$router.push({
          name: 'Orders',
          query: { toggleOrder: 'equipment' },
        });
      } else if (this.$route.query.serviceOrders && this.$store.getters.roles === 'super-admin') {
        this.$router.push({
          name: 'Orders',
          query: { toggleOrder: 'services' },
        });
      } else if (this.$route.query.patentOrders && this.$store.getters.roles === 'super-admin') {
        this.$router.push({
          name: 'Orders',
          query: { toggleOrder: 'patents' },
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
